import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,

  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const tenantId = sessionStorage.getItem("tenantId");

  config.headers = config.headers ?? {};

  // ✅ Set tenantId only if present
  if (tenantId) config.headers.tenantId = tenantId;

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default apiClient;
